var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticStyle: { "margin-bottom": "10px" } }, [
        _c(
          "div",
          {
            staticStyle: {
              display: "flex",
              gap: "10px",
              "margin-bottom": "10px",
              "flex-wrap": "wrap",
            },
          },
          [
            _c("el-input", {
              staticStyle: { width: "200px" },
              attrs: { placeholder: "分组名称", clearable: "" },
              nativeOn: {
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.handleFilter($event)
                },
              },
              model: {
                value: _vm.listQuery.keywords,
                callback: function ($$v) {
                  _vm.$set(_vm.listQuery, "keywords", $$v)
                },
                expression: "listQuery.keywords",
              },
            }),
            _vm._v(" "),
            _c("el-input", {
              staticStyle: { width: "200px" },
              attrs: { placeholder: "副标题", clearable: "" },
              nativeOn: {
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.handleFilter($event)
                },
              },
              model: {
                value: _vm.listQuery.subtitle,
                callback: function ($$v) {
                  _vm.$set(_vm.listQuery, "subtitle", $$v)
                },
                expression: "listQuery.subtitle",
              },
            }),
            _vm._v(" "),
            _c("el-input", {
              staticStyle: { width: "200px" },
              attrs: { placeholder: "适用区域及分类", clearable: "" },
              nativeOn: {
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.handleFilter($event)
                },
              },
              model: {
                value: _vm.listQuery.regionCategory,
                callback: function ($$v) {
                  _vm.$set(_vm.listQuery, "regionCategory", $$v)
                },
                expression: "listQuery.regionCategory",
              },
            }),
            _vm._v(" "),
            _c(
              "el-button",
              {
                directives: [{ name: "waves", rawName: "v-waves" }],
                attrs: { type: "primary", icon: "el-icon-search" },
                on: { click: _vm.handleFilter },
              },
              [_vm._v("\n          搜索\n        ")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                directives: [{ name: "waves", rawName: "v-waves" }],
                attrs: { icon: "el-icon-refresh" },
                on: { click: _vm.handleReset },
              },
              [_vm._v("\n          重置\n        ")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticStyle: { display: "flex", gap: "10px" } },
          [
            _c(
              "el-button",
              {
                attrs: { type: "primary", icon: "el-icon-plus" },
                on: { click: _vm.handleCreate },
              },
              [_vm._v("\n          创建分组\n        ")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                attrs: { type: "success", icon: "el-icon-upload2" },
                on: { click: _vm.handleOpenImportDialog },
              },
              [_vm._v("\n          Excel导入\n        ")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                attrs: { type: "warning", icon: "el-icon-download" },
                on: { click: _vm.handleDownloadGroupInfo },
              },
              [_vm._v("\n          下载分组信息\n        ")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                attrs: {
                  type: "danger",
                  icon: "el-icon-delete",
                  disabled: _vm.selectedGroups.length === 0,
                },
                on: { click: _vm.handleBatchClear },
              },
              [_vm._v("\n          批量清空\n        ")]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          key: _vm.tableKey,
          ref: "groupTable",
          staticStyle: { width: "100%" },
          attrs: {
            "max-height": _vm.maxHeight,
            data: _vm.dataList,
            stripe: "",
            border: "",
            fit: "",
            "highlight-current-row": "",
          },
          on: { "selection-change": _vm.handleSelectionChange },
        },
        [
          _c("el-table-column", { attrs: { type: "selection", width: "55" } }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "序号",
              type: "index",
              align: "center",
              width: "50",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "ID", prop: "id", align: "center", width: "100" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "副标题",
              prop: "subtitle",
              align: "center",
              "min-width": "120",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "适用区域及分类",
              prop: "regionCategory",
              align: "center",
              "min-width": "150",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "分组名称（中）",
              prop: "name",
              align: "center",
              "min-width": "120",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "分组名称（英）",
              prop: "nameEn",
              align: "center",
              "min-width": "120",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "隐藏分组", align: "center", width: "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    row.hideFlag === 0 ? _c("span", [_vm._v("否")]) : _vm._e(),
                    _vm._v(" "),
                    row.hideFlag === 1 ? _c("span", [_vm._v("是")]) : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "标签",
              prop: "subscript",
              align: "center",
              width: "100",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "样式",
              prop: "type",
              align: "center",
              width: "80",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    row.type === 1 ? _c("span", [_vm._v("竖排")]) : _vm._e(),
                    _vm._v(" "),
                    row.type === 2 ? _c("span", [_vm._v("横排")]) : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "关联商品", align: "center", width: "180" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          size: "mini",
                          type: "warning",
                          icon: "el-icon-view",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handleItemDialog(row.id)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n            查看(" +
                            _vm._s(row.goodsCount) +
                            ")\n          "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "分组icon", align: "center", width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    row.iconUrl === null ||
                    row.iconUrl === "" ||
                    row.iconUrl === undefined
                      ? _c("span", [
                          _vm._v("\n            未上传图片\n          "),
                        ])
                      : _c("el-image", {
                          staticStyle: { width: "80px", height: "40px" },
                          attrs: {
                            src: row.iconUrl,
                            fit: "contain",
                            "preview-src-list": [row.iconUrl],
                            "preview-teleported": "",
                          },
                        }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "生效星期",
              prop: "name",
              align: "center",
              "min-width": "120",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    row.checkedWeekdays && row.checkedWeekdays.indexOf(1) !== -1
                      ? _c("span", [_vm._v("周一")])
                      : _vm._e(),
                    _vm._v(" "),
                    row.checkedWeekdays && row.checkedWeekdays.indexOf(2) !== -1
                      ? _c("span", [_vm._v("周二")])
                      : _vm._e(),
                    _vm._v(" "),
                    row.checkedWeekdays && row.checkedWeekdays.indexOf(3) !== -1
                      ? _c("span", [_vm._v("周三")])
                      : _vm._e(),
                    _vm._v(" "),
                    row.checkedWeekdays && row.checkedWeekdays.indexOf(4) !== -1
                      ? _c("span", [_vm._v("周四")])
                      : _vm._e(),
                    _vm._v(" "),
                    row.checkedWeekdays && row.checkedWeekdays.indexOf(5) !== -1
                      ? _c("span", [_vm._v("周五")])
                      : _vm._e(),
                    _vm._v(" "),
                    row.checkedWeekdays && row.checkedWeekdays.indexOf(6) !== -1
                      ? _c("span", [_vm._v("周六")])
                      : _vm._e(),
                    _vm._v(" "),
                    row.checkedWeekdays && row.checkedWeekdays.indexOf(7) !== -1
                      ? _c("span", [_vm._v("周日")])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "生效时间",
              prop: "name",
              align: "center",
              "min-width": "120",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _vm._v(
                      "\n           " +
                        _vm._s(row.beginTimeStr) +
                        "-" +
                        _vm._s(row.endTimeStr) +
                        "\n        "
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("tableFrom.Operation"),
              align: "center",
              width: "280",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c(
                      "div",
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              size: "mini",
                              type: "primary",
                              icon: "el-icon-edit",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleEdit(row.id)
                              },
                            },
                          },
                          [_vm._v("\n               编辑\n             ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              size: "mini",
                              type: "success",
                              icon: "el-icon-document-copy",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleCopy(row.id)
                              },
                            },
                          },
                          [_vm._v("\n               复制\n             ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              size: "mini",
                              type: "danger",
                              icon: "el-icon-delete",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleDelete(row.id)
                              },
                            },
                          },
                          [_vm._v("\n               删除\n             ")]
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.total > 0
        ? _c("sw-page", {
            key: "2",
            attrs: {
              listQuery: _vm.listQuery,
              total: _vm.total,
              pos: "btmRight",
            },
            on: { retPage: _vm.retPage },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-drawer",
        {
          attrs: {
            title: _vm.editForm.id ? "编辑分组" : "新增分组",
            visible: _vm.editVisible,
            size: "700px",
            direction: "rtl",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.editVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "editFormRef",
              staticClass: "dialog-form",
              staticStyle: { padding: "15px" },
              attrs: {
                model: _vm.editForm,
                "label-width": "120px",
                rules: _vm.editRules,
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "分组名称（中）", prop: "name" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "400px" },
                    attrs: { autosize: "" },
                    model: {
                      value: _vm.editForm.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.editForm, "name", $$v)
                      },
                      expression: "editForm.name",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "分组名称（英）", prop: "nameEn" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "400px" },
                    attrs: { autosize: "" },
                    model: {
                      value: _vm.editForm.nameEn,
                      callback: function ($$v) {
                        _vm.$set(_vm.editForm, "nameEn", $$v)
                      },
                      expression: "editForm.nameEn",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "副标题", prop: "subtitle" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "400px" },
                    attrs: { autosize: "" },
                    model: {
                      value: _vm.editForm.subtitle,
                      callback: function ($$v) {
                        _vm.$set(_vm.editForm, "subtitle", $$v)
                      },
                      expression: "editForm.subtitle",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "适用区域及分类", prop: "regionCategory" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "400px" },
                    attrs: { autosize: "" },
                    model: {
                      value: _vm.editForm.regionCategory,
                      callback: function ($$v) {
                        _vm.$set(_vm.editForm, "regionCategory", $$v)
                      },
                      expression: "editForm.regionCategory",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "一级菜单", prop: "primaryMenuId" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "200px" },
                      attrs: {
                        placeholder: "请选择",
                        clearable: "",
                        filterable: "",
                      },
                      model: {
                        value: _vm.editForm.primaryMenuId,
                        callback: function ($$v) {
                          _vm.$set(_vm.editForm, "primaryMenuId", $$v)
                        },
                        expression: "editForm.primaryMenuId",
                      },
                    },
                    _vm._l(_vm.primaryMenuList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "是否为隐藏分组", prop: "hideFlag" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "200px" },
                      attrs: {
                        placeholder: "请选择",
                        clearable: "",
                        filterable: "",
                      },
                      model: {
                        value: _vm.editForm.hideFlag,
                        callback: function ($$v) {
                          _vm.$set(_vm.editForm, "hideFlag", $$v)
                        },
                        expression: "editForm.hideFlag",
                      },
                    },
                    [
                      _c("el-option", {
                        key: 0,
                        attrs: { label: "否", value: 0 },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        key: 1,
                        attrs: { label: "是", value: 1 },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "生效时间", prop: "time" } },
                [
                  _c("el-time-picker", {
                    attrs: {
                      placeholder: "起始时间",
                      "value-format": "HH:mm",
                      format: "HH:mm",
                      "picker-options": {
                        selectableRange: "00:00:00 - 23:59:00",
                      },
                    },
                    on: { change: _vm.handleBeginTimeChange },
                    model: {
                      value: _vm.editForm.beginTimeStr,
                      callback: function ($$v) {
                        _vm.$set(_vm.editForm, "beginTimeStr", $$v)
                      },
                      expression: "editForm.beginTimeStr",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-time-picker", {
                    attrs: {
                      placeholder: "结束时间",
                      "value-format": "HH:mm",
                      format: "HH:mm",
                      "picker-options": _vm.editFormEndTimeOptions,
                    },
                    model: {
                      value: _vm.editForm.endTimeStr,
                      callback: function ($$v) {
                        _vm.$set(_vm.editForm, "endTimeStr", $$v)
                      },
                      expression: "editForm.endTimeStr",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "标签", prop: "subscript" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.editForm.subscript,
                      callback: function ($$v) {
                        _vm.$set(_vm.editForm, "subscript", $$v)
                      },
                      expression: "editForm.subscript",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "样式", prop: "style" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "200px" },
                      attrs: { placeholder: "请选择", filterable: "" },
                      model: {
                        value: _vm.editForm.type,
                        callback: function ($$v) {
                          _vm.$set(_vm.editForm, "type", $$v)
                        },
                        expression: "editForm.type",
                      },
                    },
                    [
                      _c("el-option", {
                        key: 1,
                        attrs: { label: "竖排", value: 1 },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        key: 2,
                        attrs: { label: "横排", value: 2 },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "生效星期", prop: "weekdays" } },
                [
                  _c(
                    "el-checkbox",
                    { on: { change: _vm.handleCheckAllChange } },
                    [_vm._v("全选")]
                  ),
                  _vm._v(" "),
                  _c("div", { staticStyle: { margin: "15px 0" } }),
                  _vm._v(" "),
                  _c(
                    "el-checkbox-group",
                    {
                      model: {
                        value: _vm.editForm.checkedWeekdays,
                        callback: function ($$v) {
                          _vm.$set(_vm.editForm, "checkedWeekdays", $$v)
                        },
                        expression: "editForm.checkedWeekdays",
                      },
                    },
                    _vm._l(_vm.weekdays, function (day) {
                      return _c(
                        "el-checkbox",
                        { key: day.value, attrs: { label: day.value } },
                        [
                          _vm._v(
                            "\n                  " +
                              _vm._s(day.label) +
                              "\n                "
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "生效场景", prop: "scene" } },
                [
                  _c(
                    "el-checkbox-group",
                    {
                      model: {
                        value: _vm.editForm.checkedScene,
                        callback: function ($$v) {
                          _vm.$set(_vm.editForm, "checkedScene", $$v)
                        },
                        expression: "editForm.checkedScene",
                      },
                    },
                    _vm._l(_vm.scenes, function (item) {
                      return _c(
                        "el-checkbox",
                        { key: item.value, attrs: { label: item.value } },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(item.label) +
                              "\n              "
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "icon", prop: "picturePath" } },
                [
                  _c(
                    "el-upload",
                    {
                      staticClass: "upload-demo",
                      attrs: {
                        action: "#",
                        "on-remove": _vm.handleRemoveFile,
                        "file-list": _vm.uploadFileList,
                        "http-request": _vm.handlePictureUpload,
                        "on-preview": _vm.handlePreview,
                        "list-type": "picture-card",
                        "auto-upload": true,
                        accept: "image/*",
                      },
                    },
                    [_c("i", { staticClass: "el-icon-plus" })]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "upload-tip" }, [
                    _vm._v("图片格式：jpg/png，大小≤2MB，尺寸305*402"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "drawer-footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.editVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.saveEntity } },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-drawer",
        {
          attrs: {
            visible: _vm.previewDialog.visible,
            size: "400px",
            direction: "rtl",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.previewDialog, "visible", $event)
            },
          },
        },
        [
          _c("img", {
            staticStyle: { width: "100%" },
            attrs: { src: _vm.previewDialog.url, alt: "预览图" },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "分组商品",
            visible: _vm.itemVisible,
            width: "1200px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.itemVisible = $event
            },
          },
        },
        [
          _c("el-input", {
            staticStyle: { width: "200px" },
            attrs: { placeholder: "请输出商品信息", clearable: "" },
            model: {
              value: _vm.itemFilter.keywords,
              callback: function ($$v) {
                _vm.$set(_vm.itemFilter, "keywords", $$v)
              },
              expression: "itemFilter.keywords",
            },
          }),
          _vm._v(" "),
          _c(
            "el-button",
            {
              directives: [{ name: "waves", rawName: "v-waves" }],
              staticClass: "filter-item",
              attrs: { type: "primary", icon: "el-icon-search" },
              on: { click: _vm.getItems },
            },
            [_vm._v("\n           搜索\n        ")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              directives: [{ name: "waves", rawName: "v-waves" }],
              staticClass: "filter-item",
              staticStyle: { "margin-bottom": "10px" },
              attrs: { type: "primary", icon: "el-icon-plus" },
              on: { click: _vm.handleItemAddFilter },
            },
            [_vm._v("\n           添加商品\n        ")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              directives: [{ name: "waves", rawName: "v-waves" }],
              staticClass: "filter-item",
              staticStyle: { "margin-bottom": "10px" },
              attrs: { type: "danger", icon: "el-icon-delete" },
              on: { click: _vm.handleItemDeleteFilter },
            },
            [_vm._v("\n           批量删除\n        ")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              directives: [{ name: "waves", rawName: "v-waves" }],
              staticClass: "filter-item",
              staticStyle: { "margin-bottom": "10px" },
              attrs: { type: "warning", icon: "el-icon-sort" },
              on: { click: _vm.handleMigrateItems },
            },
            [_vm._v("\n           迁移商品\n        ")]
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              ref: "itemTable",
              staticStyle: { width: "100%" },
              attrs: { data: _vm.itemList, border: "" },
              on: { "selection-change": _vm.handleItemSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "商品名称", prop: "goodsName" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "商品编码", prop: "goodsCode" },
              }),
              _vm._v(" "),
              _c("el-table-column", { attrs: { label: "排序", prop: "sort" } }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("tableFrom.Operation"),
                  align: "center",
                  width: "100",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "div",
                          [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  size: "mini",
                                  type: "danger",
                                  icon: "el-icon-delete",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteItem(row.id)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                    删除\n                  "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.itemTotal > 0
            ? _c("sw-page", {
                key: "3",
                staticStyle: { display: "block", float: "none" },
                attrs: {
                  listQuery: _vm.itemFilter,
                  total: _vm.itemTotal,
                  pos: "btmRight",
                },
                on: { retPage: _vm.getItemPage },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "添加商品",
            visible: _vm.itemAddVisible,
            width: "1200px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.itemAddVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "filter-container",
              staticStyle: { "margin-bottom": "10px" },
            },
            [
              _c("el-input", {
                staticClass: "filter-item",
                staticStyle: { width: "200px" },
                attrs: { placeholder: "菜品id/名称", clearable: "" },
                nativeOn: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.handleItemAddFilter($event)
                  },
                },
                model: {
                  value: _vm.itemAddQuery.keywords,
                  callback: function ($$v) {
                    _vm.$set(_vm.itemAddQuery, "keywords", $$v)
                  },
                  expression: "itemAddQuery.keywords",
                },
              }),
              _vm._v(" "),
              _c("el-cascader", {
                staticClass: "filter-item",
                staticStyle: { width: "200px" },
                attrs: {
                  options: _vm.categories,
                  props: {
                    value: "id",
                    label: "label",
                    leaf: "leaf",
                    checkStrictly: true,
                  },
                  placeholder: "菜品分类",
                  clearable: "",
                },
                model: {
                  value: _vm.itemAddQuery.categories,
                  callback: function ($$v) {
                    _vm.$set(_vm.itemAddQuery, "categories", $$v)
                  },
                  expression: "itemAddQuery.categories",
                },
              }),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.searchAddGoods },
                },
                [_vm._v("搜索")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "success", icon: "el-icon-plus" },
                  on: { click: _vm.handleBatchAddGoods },
                },
                [_vm._v("批量添加")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.itemAddVisible = false
                    },
                  },
                },
                [_vm._v("返回")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              key: _vm.tableKey,
              ref: "itemAddTable",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.itemAddData,
                stripe: "",
                border: "",
                fit: "",
                "highlight-current-row": "",
              },
              on: { "selection-change": _vm.handleItemAddSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: {
                  type: "selection",
                  width: "55",
                  selectable: _vm.checkSelectable,
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "商品名称",
                  prop: "goodsName",
                  align: "center",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "商品编码",
                  prop: "goodsCode",
                  align: "center",
                  width: "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "所属大类",
                  prop: "categoryFirstName",
                  align: "center",
                  width: "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "所属小类",
                  prop: "categorySecondName",
                  align: "center",
                  width: "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "商品图", align: "center", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        row.goodsThumbnailUrl === null ||
                        row.goodsThumbnailUrl === "" ||
                        row.goodsThumbnailUrl === undefined
                          ? _c("span", [
                              _vm._v(
                                "\n              未上传图片\n            "
                              ),
                            ])
                          : _c("el-image", {
                              staticStyle: { width: "80px", height: "40px" },
                              attrs: {
                                src: row.goodsThumbnailUrl,
                                fit: "contain",
                                "preview-src-list": [row.goodsThumbnailUrl],
                                "preview-teleported": "",
                              },
                            }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  fixed: "right",
                  label: _vm.$t("tableFrom.Operation"),
                  align: "center",
                  width: "250",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "div",
                          [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  disabled: row.checked,
                                  size: "mini",
                                  type: "success",
                                  icon: "el-icon-collection",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.addGoods(row.id)
                                  },
                                },
                              },
                              [_vm._v("\n                添加\n              ")]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.itemAddTotal > 0
            ? _c("sw-page", {
                key: "4",
                staticStyle: { display: "block", float: "none" },
                attrs: {
                  listQuery: _vm.itemAddQuery,
                  total: _vm.itemAddTotal,
                  pos: "btmRight",
                },
                on: { retPage: _vm.getItemAddPage },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "批量清空分组商品",
            visible: _vm.batchClearDialogVisible,
            width: "600px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.batchClearDialogVisible = $event
            },
            close: _vm.handleBatchClearDialogClose,
          },
        },
        [
          _c("el-alert", {
            staticStyle: { "margin-bottom": "20px" },
            attrs: {
              title: "警告：此操作将清空所选分组下的所有商品，请谨慎操作！",
              type: "warning",
              closable: false,
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "batch-clear-content" },
            [
              _c("p", [
                _vm._v("即将清空以下 "),
                _c("strong", [_vm._v(_vm._s(_vm.selectedGroups.length))]),
                _vm._v(" 个分组的所有商品："),
              ]),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  staticStyle: {
                    width: "100%",
                    "margin-top": "10px",
                    "max-height": "300px",
                    "overflow-y": "auto",
                  },
                  attrs: { data: _vm.selectedGroups, border: "" },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: "分组ID",
                      prop: "id",
                      align: "center",
                      width: "100",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "分组名称", prop: "name", align: "center" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "关联商品数",
                      prop: "goodsCount",
                      align: "center",
                      width: "120",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.batchClearDialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "danger", loading: _vm.batchClearing },
                  on: { click: _vm.handleFirstConfirm },
                },
                [_vm._v("\n          第一次确认\n        ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "第二次确认",
            visible: _vm.secondConfirmDialogVisible,
            width: "400px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.secondConfirmDialogVisible = $event
            },
          },
        },
        [
          _c("el-alert", {
            staticStyle: { "margin-bottom": "15px" },
            attrs: {
              title:
                "最后确认！此操作不可撤销，确定要清空这些分组的所有商品吗？",
              type: "error",
              closable: false,
            },
          }),
          _vm._v(" "),
          _c(
            "p",
            {
              staticStyle: {
                color: "#f56c6c",
                "font-weight": "bold",
                "text-align": "center",
                "font-size": "16px",
              },
            },
            [
              _vm._v(
                "\n        清空分组数：" +
                  _vm._s(_vm.selectedGroups.length) +
                  " 个\n      "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.secondConfirmDialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "danger", loading: _vm.batchClearing },
                  on: { click: _vm.handleSecondConfirm },
                },
                [_vm._v("\n          确认清空\n        ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Excel导入分组商品",
            visible: _vm.importDialogVisible,
            width: "600px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.importDialogVisible = $event
            },
            close: _vm.handleImportDialogClose,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "importFormRef",
              staticClass: "import-form",
              attrs: {
                model: _vm.importForm,
                "label-position": "top",
                "label-width": "auto",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "操作类型" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.importForm.operation,
                        callback: function ($$v) {
                          _vm.$set(_vm.importForm, "operation", $$v)
                        },
                        expression: "importForm.operation",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "import" } }, [
                        _vm._v("导入商品"),
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: "delete" } }, [
                        _vm._v("删除商品"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "导入模板" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", icon: "el-icon-download" },
                      on: { click: _vm.handleDownloadTemplate },
                    },
                    [_vm._v("\n            下载导入模板\n          ")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "导入数据" } },
                [
                  _c(
                    "el-upload",
                    {
                      ref: "uploadRef",
                      staticClass: "import-upload",
                      attrs: {
                        limit: 1,
                        accept: ".xlsx",
                        headers: _vm.uploadHeaders,
                        action: _vm.uploadUrl,
                        "on-success": _vm.handleUploadSuccess,
                        "on-error": _vm.handleUploadError,
                        "auto-upload": false,
                        data: _vm.uploadData,
                        disabled: _vm.importing,
                        drag: "",
                      },
                    },
                    [
                      _c("i", { staticClass: "el-icon-upload" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "el-upload__text" }, [
                        _vm._v("\n              将文件拖到此处，或"),
                        _c("em", [_vm._v("点击上传")]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "el-upload__tip",
                          attrs: { slot: "tip" },
                          slot: "tip",
                        },
                        [
                          _vm._v(
                            "\n              只能上传 xlsx 文件，且不超过 5MB\n            "
                          ),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    disabled:
                      _vm.importing && _vm.importTaskStatus === "running",
                  },
                  on: {
                    click: function ($event) {
                      _vm.importDialogVisible = false
                    },
                  },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.importing ? "后台执行中..." : "取消") +
                      "\n        "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    loading: _vm.importing && !_vm.importTaskVisible,
                  },
                  on: { click: _vm.handleConfirmImport },
                },
                [_vm._v("\n          确认导入\n        ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "迁移商品",
            visible: _vm.migrateDialogVisible,
            width: "600px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.migrateDialogVisible = $event
            },
            close: _vm.handleMigrateDialogClose,
          },
        },
        [
          _c("el-alert", {
            staticStyle: { "margin-bottom": "20px" },
            attrs: {
              title:
                "提示：迁移后将把当前选中的商品移动到目标分组，当前分组不再保留这些商品。同时会迁移菜单模板和门店菜单的相关分组。",
              type: "warning",
              closable: false,
            },
          }),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "migrateFormRef",
              staticClass: "migrate-form",
              attrs: { model: _vm.migrateForm, "label-width": "120px" },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "当前分组" } },
                [
                  _c("el-input", {
                    attrs: { value: _vm.currentGroupName, disabled: "" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "选中商品数" } },
                [
                  _c("el-input", {
                    attrs: { value: _vm.selectedItemCount, disabled: "" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "目标分组",
                    prop: "targetGroupId",
                    rules: [
                      {
                        required: true,
                        message: "请选择目标分组",
                        trigger: "change",
                      },
                    ],
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        placeholder: "请选择目标分组",
                        filterable: "",
                        clearable: "",
                      },
                      model: {
                        value: _vm.migrateForm.targetGroupId,
                        callback: function ($$v) {
                          _vm.$set(_vm.migrateForm, "targetGroupId", $$v)
                        },
                        expression: "migrateForm.targetGroupId",
                      },
                    },
                    _vm._l(_vm.groupOptions, function (item) {
                      return _c(
                        "el-option",
                        {
                          key: item.id,
                          attrs: {
                            label: item.name,
                            value: item.id,
                            disabled: item.id === _vm.itemFilter.groupId,
                          },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                float: "left",
                                "font-weight": "500",
                              },
                            },
                            [_vm._v(_vm._s(item.name))]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                float: "right",
                                color: "#8492a6",
                                "font-size": "12px",
                                "max-width": "300px",
                                overflow: "hidden",
                                "text-overflow": "ellipsis",
                                "white-space": "nowrap",
                              },
                            },
                            [
                              item.subtitle
                                ? _c("span", [_vm._v(_vm._s(item.subtitle))])
                                : _vm._e(),
                              _vm._v(" "),
                              item.subtitle && item.regionCategory
                                ? _c("span", [_vm._v(" | ")])
                                : _vm._e(),
                              _vm._v(" "),
                              item.regionCategory
                                ? _c("span", [
                                    _vm._v(_vm._s(item.regionCategory)),
                                  ])
                                : _vm._e(),
                            ]
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.migrateDialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "warning", loading: _vm.migrating },
                  on: { click: _vm.handleConfirmMigrate },
                },
                [_vm._v("\n          确认迁移\n        ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }